import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginService } from '../../auth/login.service';
import { loginNavigationExtras } from '../../auth/safe-return-url';
import { crmHomeRoute } from '../utils/crm-home-route';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.loginService.ensureSession().pipe(
      map(ok => {
        if (!ok) {
          void this.router.navigate(['/login'], loginNavigationExtras(state.url));
          return false;
        }

        // Shell routes (profile): any authenticated CRM user.
        if (route.data['allowAuthenticated'] === true) {
          return true;
        }

        const requiredPermissions = route.data['permissions'] as string[] | undefined;

        // Fail-closed: routes with PermissionGuard must declare permissions or allowAuthenticated.
        // Fallback prefers hub when allowed; otherwise profile (avoids /dashboard deny loops).
        if (!requiredPermissions || requiredPermissions.length === 0) {
          this.router.navigate([crmHomeRoute(p => this.loginService.hasAnyPermission(p))]);
          return false;
        }

        const hasPermission = this.loginService.hasAnyPermission(requiredPermissions);

        if (!hasPermission) {
          this.router.navigate([crmHomeRoute(p => this.loginService.hasAnyPermission(p))]);
          return false;
        }

        return true;
      })
    );
  }
}
